function HeroHeading({ children }) {
    return (
        <h1 className="text-3xl md:text-5xl leading-11 md:leading-14 font-bold text-black">
            {children}
        </h1>
    )
}

export default HeroHeading
